export const ACTION_START = 'START'
export const ACTION_STOP = 'STOP'
export const ACTION_UPDATE = 'UPDATE'
export const ACTION_TICK = 'TICK'
export const TICKS_PER_BEAT_BINARY = 16
export const TICKS_PER_BEAT_TERNARY = 12
export const SECONDS_IN_MINUTE = 60
export const SCHEDULE_AHEAD_TIME = 0.1
